import React, { useEffect, useState } from "react";
import { list, add, edit, detail } from "../../services/wallet.services";
import { LOADER_TIMEOUT_TIME, ROLE, SORT_A, SORT_D, SWAL_SETTINGS } from "../../../../utils/Constants";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import { useValidationSchemas } from "../../validator/validation";
import { useTranslation } from "react-i18next";
import { formateDate, getUser, handleOffcanvasScroll, handleServerValidations, TrimText } from "../../../../utils/commonfunction";
import CustomError from "../../../../utils/customError";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { DatePicker, Drawer } from "rsuite";
import Skeleton from "react-loading-skeleton";
import { centerProfileDetails } from "../../services/profile.services";
import CustomPagination from "../../../admin/common/custompagination";
import RecordNotFound from "../../shared/recordNotFound";

export default function Wallet() {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const { t } = useTranslation();
    const [List, setList] = useState([]);
    const { walletValidationSchema, editScheduleValidationSchema } = useValidationSchemas();
    const [refreshList, setRefreshList] = useState(false);
    const [openWithHeader, setOpenWithHeader] = useState(false);
    const [openWithHeaderEdit, setOpenWithHeaderEdit] = useState(false);
    const [prevGlobalSearch, setPrevGlobalSearch] = useState("");
    const [globalSearch, setGlobalSearch] = useState("");
    const [search, setSearch] = useState({});
    const [loader, setLoader] = useState(true);
    const [scheduleDetail, setScheduleDetail] = useState({});
    const [page, setPage] = useState(1);
    const [offset, setOffsetPage] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [itemPerPage] = useState(10);
    const [sortConfig, setSortConfig] = useState({ column: "createdAt", order: SORT_D });
    const [sortHistoryConfig, setSortHistoryConfig] = useState({ column: "date", order: SORT_D });
    const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
    const [editSubmissionLoader, setEditSubmissionLoader] = useState(false);
    const [walletBalance, setWalletBalance] = useState();
    const [activeTab, setActiveTab] = useState("credit");

    useEffect(() => {
        setLoader(true);
        const formData = new FormData();
        if (Object.keys(search).length) {
            formData.append("search", JSON.stringify(search));
        }
        formData.append("global_search", globalSearch);
        let page = params.page;
        if (globalSearch) {
            if (prevGlobalSearch !== globalSearch || !prevGlobalSearch) {
                page = 1;
            }
            setPage(page);
        }
        formData.append("page", page);
        formData.append("per_page", itemPerPage);
        formData.append("transaction_type", activeTab);
        if (sortConfig) {
            formData.append("sort", JSON.stringify(sortConfig));
        }
        list(formData)
            .then((data) => {
                if (data && data.data) {
                    setList(data.data.list || []);
                    setPage(data.data.page);
                    navigate(`/center/wallet/${data.data.page}`);
                    setOffsetPage(data.data.offset);
                    setTotalRecords(data.data.total_records || 0);
                } else {
                    setList([]);
                    setOffsetPage(0);
                    setTotalRecords(0);
                }
                setPrevGlobalSearch(globalSearch);
                setTimeout(() => {
                    setLoader(false);
                }, LOADER_TIMEOUT_TIME);
            })
            .catch((error) => {
                console.log("error ====> ", error);
                setTimeout(() => {
                    setLoader(false);
                }, LOADER_TIMEOUT_TIME);
            });
    }, [search, refreshList, globalSearch, params.page, sortConfig, activeTab]);

    const addForm = useFormik({
        initialValues: {
            amount: "",
        },
        validationSchema: walletValidationSchema,
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            const formData = new FormData();
            formData.append("wallet_balance", values.amount);
            setAddSubmissionLoader(true);
            add(formData)
                .then((response) => {
                    setAddSubmissionLoader(false);
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        resetForm();
                        setOpenWithHeader(false);
                        setRefreshList(!refreshList);
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                    }
                })
                .catch((error) => {
                    setAddSubmissionLoader(false);
                    console.error("Error updating profile", error);
                });
        },
    });

    function extractTime(createdAt) {
        return new Date(createdAt).toLocaleTimeString("en-US", {
            hour12: false,
            hour: "2-digit",
            minute: "2-digit",
        });
    }

    useEffect(() => {
        const userId = getUser(ROLE.CENTER)?._id;
        centerProfileDetails({ o_id: userId }, userId)
            .then((data) => {
                setTimeout(() => {
                    setLoader(false);
                }, LOADER_TIMEOUT_TIME);
                setWalletBalance(data?.data?.wallet_balance);
            })
            .catch((err) => {
                setTimeout(() => {}, LOADER_TIMEOUT_TIME);
                console.log(err);
            });
    }, [refreshList]);

    return (
        <main id="main-content">
            <div className="mt-4 ms-3 me-3">
                <div className="dashboard-cards mb-4">
                    <div className="row">
                        <div className="col-md-12 d-flex">
                            <div className="card w-100">
                                <div className="card-body d-flex align-items-center gap-3">
                                    <figure className="card-icon-color-3">
                                        <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M21.75 10.5V6.75C21.75 6.41848 21.6183 6.10054 21.3839 5.86612C21.1495 5.6317 20.8315 5.5 20.5 5.5H8C7.33696 5.5 6.70107 5.76339 6.23223 6.23223C5.76339 6.70107 5.5 7.33696 5.5 8M5.5 8C5.5 8.66304 5.76339 9.29893 6.23223 9.76777C6.70107 10.2366 7.33696 10.5 8 10.5H23C23.3315 10.5 23.6495 10.6317 23.8839 10.8661C24.1183 11.1005 24.25 11.4185 24.25 11.75V15.5M5.5 8V23C5.5 23.663 5.76339 24.2989 6.23223 24.7678C6.70107 25.2366 7.33696 25.5 8 25.5H23C23.3315 25.5 23.6495 25.3683 23.8839 25.1339C24.1183 24.8995 24.25 24.5815 24.25 24.25V20.5M25.5 15.5V20.5H20.5C19.837 20.5 19.2011 20.2366 18.7322 19.7678C18.2634 19.2989 18 18.663 18 18C18 17.337 18.2634 16.7011 18.7322 16.2322C19.2011 15.7634 19.837 15.5 20.5 15.5H25.5Z"
                                                stroke="white"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                    </figure>
                                    <figcaption>
                                        <span>Wallet Amount</span>
                                        <h4>₹ {walletBalance ? walletBalance : 0}</h4>
                                    </figcaption>

                                    <button
                                        className="btn btn-primary ms-auto"
                                        onClick={() => {
                                            setOpenWithHeader(true);
                                        }}
                                    >
                                        ADD FUNDS+
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        <h3 className="mb-3">Recent Transactions</h3>
                        <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button className={`nav-link ${activeTab === "credit" ? "active" : ""}`} onClick={() => setActiveTab("credit")} type="button" role="tab">
                                    Credit
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className={`nav-link ${activeTab === "debit" ? "active" : ""}`} onClick={() => setActiveTab("debit")} type="button" role="tab">
                                    Debit
                                </button>
                            </li>
                        </ul>
                        <div class="tab-content" id="pills-tabContent">
                            <div class="tab-pane fade show active" id="pills-Credit" role="tabpanel" aria-labelledby="pills-Credit-tab" tabindex="0">
                                <div className="table-responsive mt-2">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Transaction ID</th>
                                                <th>Amount</th>
                                                <th>Date</th>
                                                <th>Time</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loader ? (
                                                <td colSpan={4}>
                                                    <Skeleton className="mb-2" height={50} count={5} />
                                                </td>
                                            ) : List.length > 0 ? (
                                                List.map((txn, index) => (
                                                    <tr key={index}>
                                                        <td>{txn?.transaction_id}</td>
                                                        <td>₹ {txn.amount}</td>
                                                        <td>{formateDate(txn.createdAt)}</td>
                                                        <td>{extractTime(txn.createdAt)}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <td colSpan={4}>
                                                    <RecordNotFound heading="center.staff.no_staff_found" />
                                                </td>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="table-status-info d-flex justify-content-between align-items-center">
                                    <span>
                                        {t("center.staff.label_showing")} {offset + List.length} of {totalRecords} {t("center.staff.label_entries")}
                                    </span>
                                    <nav aria-label="Page navigation example" title={page}>
                                        {totalRecords && totalRecords > 0 ? (
                                            <CustomPagination
                                                datalength={totalRecords}
                                                itemperpage={itemPerPage}
                                                currentPage={page}
                                                custompath="page"
                                                setPage={setPage}
                                                pageRoute={[{ name: "settings", path: "/center/wallet" }]}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </nav>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="pills-Debit" role="tabpanel" aria-labelledby="pills-Debit-tab" tabindex="0">
                                <div className="table-responsive mt-2">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Transaction ID</th>
                                                <th>Amount</th>
                                                <th>Date</th>
                                                <th>Time</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loader ? (
                                                <div className="w-100">
                                                    <Skeleton className="mb-2" height={50} count={5} />
                                                </div>
                                            ) : List.length > 0 ? (
                                                List.map((txn, index) => (
                                                    <tr key={index}>
                                                        <td>#12345</td>
                                                        <td>₹ {txn.amount}</td>
                                                        <td>{formateDate(txn.createdAt)}</td>
                                                        <td>{extractTime(txn.createdAt)}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <RecordNotFound heading="center.staff.no_staff_found" />
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* add item modal */}
            <Drawer open={openWithHeader}>
                <Drawer.Header closeButton={false}>
                    <div className="d-flex justify-content-between w-100 align-items-center">
                        <h3 className="mb-0">{t("Add Funds")}</h3>
                        <button
                            className="btn-icon"
                            onClick={() => {
                                setOpenWithHeader(false);
                                addForm.resetForm();
                            }}
                        >
                            <i className="ri-close-fill"></i>
                        </button>
                    </div>
                </Drawer.Header>
                <Drawer.Body
                    onScroll={(e) => {
                        handleOffcanvasScroll(e, "editNewEmail", "rsuite");
                    }}
                >
                    <form onSubmit={addForm.handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label">
                                {t("Amount")}
                                <span>*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t("Enter amount")}
                                name="amount"
                                value={addForm?.values?.amount}
                                onChange={addForm.handleChange}
                                onBlur={addForm.handleBlur}
                            />
                            <CustomError name="amount" form={addForm} className="text-danger" />
                        </div>
                        {/* Submit Button */}
                        <div className="button-form">
                            <button type="submit" className={"btn btn-primary w-100" + (addSubmissionLoader ? " btn-loader" : "")}>
                                Add
                            </button>
                        </div>
                    </form>
                </Drawer.Body>
            </Drawer>
        </main>
    );
}
